// Default role data structure for PMS
const DEFAULT_ROLE_DATA = [
    {
        "eventKey": "dashboard",
        "label": "Dashboard",
        "path": "/:lng/dashboard",
        "crud": false,
        "read": false,
        "write": false,
        "subeventKey": [
            {
                "eventKey": "financial_insights",
                "label": "Financial Insights",
                "crud": false,
                "read": false,
                "write": false
            },
            {
                "eventKey": "frontdesk",
                "label": "Front Desk",
                "crud": false,
                "read": false,
                "write": false, 
                "actions": {
                    "check_in": false,
                    "check_out": false,
                    "confirm": false
                }
            },
            {
                "eventKey": "housekeeping",
                "label": "Housekeeping",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    "mark_clean": false,
                    "mark_ready": false
                }
            },
            {
                "eventKey": "occupancycalendar",
                "label": "Inventory Overview",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    "book_now": false,
                    "assign_room": false,
                    "assign_room_no": false,
                    "add_guest": false,
                    "remove_guest": false
                }
            }
        ]
    },
    // {
    //     "eventKey": "user",
    //     "label": "User Profile",
    //     "path": "/:lng/home/user",
    //     "crud": false,
    //     "read": false,
    //     "write": false,
    //     "subeventKey": [
    //         {
    //             "eventKey": "personal",
    //             "label": "Personal",
    //             "crud": false,
    //             "read": false,
    //             "write": false,
    //             "actions": {
    //                 "edit": false,
    //                 "upload_photo": false
    //             }
    //         },
    //         {
    //             "eventKey": "professional",
    //             "label": "Professional",
    //             "crud": false,
    //             "read": false,
    //             "write": false,
    //             "actions": {
    //                 "edit": false
    //             }
    //         }
    //     ]
    // },
    {
        "eventKey": "branch",
        "label": "Branches",
        "path": "/:lng/home/branch",
        "crud": false,
        "read": false,
        "write": false,
        // "subeventKey": [
        //     {
        //         "eventKey": "calendar_view",
        //         "label": "Calendar view ",
        //         "path": "/:lng/home/branch",
        //         "crud": false,
        //         "read": false,
        //         "write": false,
        //         "actions": {
        //             "update": false
        //         }
        //     }
        // ],
        "actions": {
            "create": false,
            "edit": false,
            "change_status": false,
            "live_status":false,
            "cm_setting": false,
            "full_sync": false,
            "disconnect_property": false,
            "configure_payment_gateway": false
        }
    },
    {
        "eventKey": "room_features",
        "label": "Room Features",
        "path": "/:lng/home/room_features",
        "crud": false,
        "read": false,
        "write": false,
        "actions": {
            // "create": false,
            "edit": false,
            "delete": false,
            "change_status": false
        }
    },
    {
        "eventKey": "variants",
        "label": "Variant",
        "path": "/:lng/home/variant",
        "crud": false,
        "read": false,
        "write": false,
        "actions": {
            "create": false,
            "edit": false,
            "delete": false,
            "duplicate_variant": false
        }
    },
    {
        "eventKey": "room_type",
        "label": "Room Types",
        "path": "/:lng/home/room_type",
        "crud": false,
        "read": false,
        "write": false,
        "actions": {
            "create": false,
            "edit": false,
            "delete": false
        }
    },
    {
        "eventKey": "booking_room",
        "label": "Bookings",
        "path": "/:lng/home/booking_room",
        "crud": false,
        "read": false,
        "write": false,
        "actions": {
            "create": false,
            "edit": false,
            // "delete": false,
            "cancel": false,
            "check_in": false,
            "check_out": false,
            // "booking_details":false,            
            // "assign_room": false,
            // "assign_room_no": false,
            // "apply_discount": false,
            "mark_as_completed":false,
            "mark_as_confirmed":false,
            "add_extra_service": false,
            "update_functional_plan":false,
            "room_management":false,
            "lock_guest_details_editing":false,
            // "remove_service": false,
            "payment": false,
            "item_settlement":false,
            "transfer_folio": false,
            "guest_details": false,
            "view_audit_history": false,
            "export": false,
            "resend_payment_details": false,
            "update_customer_details": false,
            "resend_booking_details": false,
            // "send_invoice": false,
            // "generate_invoice": false,
            // "print_invoice": false,
            "download_invoice": false
        }
    },
    {
        "eventKey": "inventory",
        "label": "Inventory",
        "path": "/:lng/home/inventory",
        "crud": false,
        "read": false,
        "write": false,
        "subeventKey": [
            {
                "eventKey": "category",
                "label": "Category",
                "path": "/:lng/home/inventory/category",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    "create": false,
                    "edit": false,
                    "delete": false,
                    "change_status": false
                }
            },
            {
                "eventKey": "item_master",
                "label": "Item Master",
                "path": "/:lng/home/inventory/item_master",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    "create": false,
                    "edit": false,
                    "delete": false,
                    "change_status": false,
                    "export": false
                }
            },
            {
                "eventKey": "purchase_order",
                "label": "Purchase Order",
                "path": "/:lng/home/inventory/purchase_order",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    "create": false,
                    "edit": false,
                    "view": false,
                    "export": false
                }
            },
            {
                "eventKey": "room_item_inventory",
                "label": "Room Item Inventory",
                "path": "/:lng/home/inventory/room_item_inventory",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    "create": false,
                    "edit": false,
                    "delete": false,
                    "view": false,
                    "export": false
                }
            },
            {
                "eventKey": "item_consumption_log",
                "label": "Item Consumption Log",
                "path": "/:lng/home/inventory/item_consumption_log",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    "create": false,
                    "delete": false,
                    "export": false
                }
            },
            {
                "eventKey": "item_damage_log",
                "label": "Item Damage Log",
                "path": "/:lng/home/inventory/item_damage_log",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    "create": false,
                    "edit": false,
                    "delete": false,
                    "export": false
                }
            }
        ]
    },
    {
        "eventKey": "block_room",
        "label": "Block Room",
        "path": "/:lng/home/block_room",
        "crud": false,
        "read": false,
        "write": false
    },
    {
        "eventKey": "room_facility",
        "label": "Room Facilities",
        "path": "/:lng/home/room_facility",
        "crud": false,
        "read": false,
        "write": false,
        "actions": {
            "create": false,
            "edit": false,
            "delete": false,
            "change_status": false
        }
    },
    {
        "eventKey": "amenities",
        "label": "Hotel Amenities",
        "path": "/:lng/home/amenities",
        "crud": false,
        "read": false,
        "write": false,
        "actions": {
            "create": false,
            "edit": false,
            "delete": false,
            "change_status": false
        }
    },
    {
        "eventKey": "booking_rules",
        "label": "Booking Rules",
        "path": "/:lng/settings/booking_rules",
        "crud": false,
        "read": false,
        "write": false,
        "actions": {
            "create": false,
            "edit": false,
            "delete": false
        }
    },
    {
        "eventKey": "cancellation_rules",
        "label": "Cancellation Rules",
        "path": "/:lng/settings/cancellation_rules",
        "crud": false,
        "read": false,
        "write": false,
        "actions": {
            "create": false,
            "edit": false,
            "delete": false
        }
    },
    {
        "eventKey": "tax",
        "label": "Tax Rules",
        "path": "/:lng/settings/tax",
        "crud": false,
        "read": false,
        "write": false,
        "actions": {
            // "create": false,
            "branchEdit": false,
            "orgEdit":false,
            "orgDelete": false,
            "orgChange_status": false,
            "branchChange_status":false
        }
    },
    {
        "eventKey": "register_master_folio",
        "label": "Register Master Folio",
        "path": "/:lng/settings/folio",
        "crud": false,
        "read": false,
        "write": false,
        "actions": {
            "create": false,
            "view":false,
            "edit":false
        }
    },
    {
        "eventKey": "role",
        "label": "Roles",
        "path": "/:lng/settings/role",
        "crud": false,
        "read": false,
        "write": false,
        "actions": {
            "create": false,
            "delete": false,
            "change_status": false,
            "manage_permissions": false
        }
    },
    // {
    //     "eventKey": "staff",
    //     "label": "Staffs",
    //     "path": "/:lng/settings/staff",
    //     "crud": false,
    //     "read": false,
    //     "write": false,
    //     "subeventKey": [
    //         {
    //             "eventKey": "personal",
    //             "label": "Personal",
    //             "crud": false,
    //             "read": false,
    //             "write": false
    //         },
    //         {
    //             "eventKey": "professional",
    //             "label": "Professional",
    //             "crud": false,
    //             "read": false,
    //             "write": false
    //         }
    //     ]
    // },
    {
        "eventKey": "quotation",
        "label": "Quotations",
        "path": "/:lng/home/quotation",
        "crud": false,
        "read": false,
        "write": false,
        "actions": {
            "create": false,
            "edit": false,
            "delete": false,
            "convert_to_booking": false,
            "send_quotation": false,
            "resend_quotation": false,
            "export": false
        }
    },
    {
        "eventKey": "credit_note",
        "label": "Credit Notes",
        "path": "/:lng/home/credit_note",
        "crud": false,
        "read": false,
        "write": false,
        "actions": {
        }
    },
    {
        "eventKey": "package_tour",
        "label": "Tour",
        "path": "/:lng/home/package_tour",
        "crud": false,
        "read": false,
        "write": false,
        "actions": {
            "create": false,
            "edit": false,
            "delete": false,
            "change_status": false
        }
    },
    {
        "eventKey": "reports",
        "label": "Reports",
        "crud": false,
        "read": false,
        "write": false,
        "subeventKey": [
            {
                "eventKey": "occupancy_summary",
                "label": "Occupancy Summary",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    "export": false,
                    "download_pdf": false,
                    "filter_data": false
                }
            },
            {
                "eventKey": "in_house_report",
                "label": "In-House Report",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    "export": false,
                    "download_pdf": false,
                    "filter_data": false
                }
            },
            {
                "eventKey": "expected_arrival",
                "label": "Expected Arrival",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    "export": false,
                    "download_pdf": false,
                    "filter_data": false
                }
            },
            {
                "eventKey": "check_in_report",
                "label": "Check-In Report",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    "export": false,
                    "download_pdf": false,
                    "filter_data": false
                }
            },
            {
                "eventKey": "checkout_report",
                "label": "Checkout Report",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    "export": false,
                    "download_pdf": false,
                    "filter_data": false
                }
            },
            {
                "eventKey": "guest_ledger",
                "label": "Guest Ledger",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    "export": false,
                    "download_pdf": false,
                    "filter_data": false
                }
            },
            {
                "eventKey": "no_show_report",
                "label": "No Show Report",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    "export": false,
                    "download_pdf": false,
                    "filter_data": false
                }
            },
            {
                "eventKey": "early_checkout",
                "label": "Early Checkout",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    "export": false,
                    "download_pdf": false,
                    "filter_data": false
                }
            },
            {
                "eventKey": "cancellations_report",
                "label": "Cancellations Report",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    "export": false,
                    "download_pdf": false,
                    "filter_data": false
                }
            },
            {
                "eventKey": "payment_transactions",
                "label": "Payment Transactions",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    "export": false,
                    "download_pdf": false,
                    "filter_data": false
                }
            },
            {
                "eventKey": "daily_flash_report",
                "label": "Daily Flash Report",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    "export": false,
                    "download_pdf": false,
                    "filter_data": false
                }
            },
            {
                "eventKey": "sales_summary",
                "label": "Sales Summary",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    "export": false,
                    "download_pdf": false,
                    "filter_data": false
                }
            },
            {
                "eventKey": "room_tariff_report",
                "label": "Room Tariff Report",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    "export": false,
                    "download_pdf": false,
                    "filter_data": false
                }
            },
            // {
            //     "eventKey": "night_audit",
            //     "label": "Night Audit",
            //     "crud": false,
            //     "read": false,
            //     "write": false
            // },
            // {
            //     "eventKey": "segment_analysis",
            //     "label": "Segment Analysis",
            //     "crud": false,
            //     "read": false,
            //     "write": false
            // },
            // {
            //     "eventKey": "complimentary",
            //     "label": "Complimentary",
            //     "crud": false,
            //     "read": false,
            //     "write": false
            // },
            {
                "eventKey": "extra_charges",
                "label": "Extra Charges",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    "export": false,
                    "download_pdf": false,
                    "filter_data": false
                }
            },
            {
                "eventKey": "ota_performance",
                "label": "OTA Performance",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    "export": false,
                    "download_pdf": false,
                    "filter_data": false
                }
            },
            {
                "eventKey": "f&b_billing",
                "label": "F&B Billing",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    "export": false,
                    "download_pdf": false,
                    "filter_data": false
                }
            },
            {
                "eventKey": "all_billing",
                "label": "All Billing",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    "export": false,
                    "download_pdf": false,
                    "filter_data": false
                }
            },
            // {
            //     "eventKey": "tax_report",
            //     "label": "Tax Report",
            //     "crud": false,
            //     "read": false,
            //     "write": false
            // },
            {
                "eventKey": "settlement_report",
                "label": "Settlement Report",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    "export": false,
                    "download_pdf": false,
                    "filter_data": false
                }
            },
            {
                "eventKey": "general_collection",
                "label": "General Collection",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    "export": false,
                    "download_pdf": false,
                    "filter_data": false
                }
            },
            {
                "eventKey": "vendor_payments",
                "label": "Vendor Payment",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    "export_vendor_summary": false,
                    "export_transactions": false
                }
            },
            {
                "eventKey": "staff_account_collection",
                "label": "Staff Account Collection",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    "export_staff_summary": false,
                    "export_transactions": false
                }
            },
            // {
            //     "eventKey": "shift_wise_collection",
            //     "label": "Shift Wise Collection",
            //     "crud": false,
            //     "read": false,
            //     "write": false
            // },
            {
                "eventKey": "gstr_1_report",
                "label": "GSTR-1 Report",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    "export_staff_summary": false,
                    "export_transactions": false
                }
            },
            {
                "eventKey": "gstr_3b_report",
                "label": "GSTR-3B Report",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    "export_staff_summary": false,
                    "export_transactions": false
                }
            },
            {
                "eventKey": "hsn_sac_summary",
                "label": "HSN/SAC Summary",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    "export_staff_summary": false,
                    "export_transactions": false
                }
            },
            {
                "eventKey": "itc_report",
                "label": "ITC Report",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    "export_staff_summary": false,
                    "export_transactions": false
                }
            },
            {
                "eventKey": "purchase_register",
                "label": "Purchase Register",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    "export_staff_summary": false,
                    "export_transactions": false
                }
            },
            {
                "eventKey": "credit_notes",
                "label": "Credit Notes",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    "export_staff_summary": false,
                    "export_transactions": false
                }
            },
            {
                "eventKey": "tax_rate_wise_gst",
                "label": "Tax Rate Wise GST",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    "export_staff_summary": false,
                    "export_transactions": false
                }
            },
            {
                "eventKey": "cancellation_gst",
                "label": "Cancellation GST",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    "export_staff_summary": false,
                    "export_transactions": false
                }
            },
            {
                "eventKey": "folio_transfer_report",
                "label": "Folio Transfer Report",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    "export_staff_summary": false,
                    "export_transactions": false
                }
            },
             // {
            //     "eventKey": "folio_balance_report",
            //     "label": "Folio Balance Report",
            //     "crud": false,
            //     "read": false,
            //     "write": false
            // },
            // {
            //     "eventKey": "folio_adjustment_report",
            //     "label": "Folio Adjustment Report",
            //     "crud": false,
            //     "read": false,
            //     "write": false
            // },
            {
                "eventKey": "general_report",
                "label": "General Report",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    "export_staff_summary": false,
                    "export_transactions": false
                }
            }
            // {
            //     "eventKey": "policy_report",
            //     "label": "Policy Report",
            //     "crud": false,
            //     "read": false,
            //     "write": false
            // },
            // {
            //     "eventKey": "feedback_report",
            //     "label": "Feedback Report",
            //     "crud": false,
            //     "read": false,
            //     "write": false
            // },
        ]
    },
    {
        "eventKey": "account_payment",
        "label": "Account & Payments",
        "path": "/:lng/home/account_payments",
        "crud": false,
        "read": false,
        "write": false,
        "subeventKey": [
            {
                "eventKey": "beneficiaries",
                "label": "Vendors",
                "path": "/:lng/home/account_payment/beneficiaries",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    "create": false,
                    "edit": false,
                    "make_payment": false,
                    "api_key": false
                }
            },
            {
                "eventKey": "pending_settlements",
                "label": "Pending Settlements",
                "path": "/:lng/home/account_payment/pending_settlements",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    "create": false,
                    "individual_settlement": false,
                    "view_outsource_bill": false
                }
            },
            {
                "eventKey": "transactions",
                "label": "Transactions",
                "path": "/:lng/home/account_payment/transactions",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    "create": false,
                    // "void": false
                }
            },
            {
                "eventKey": "vendor_report",
                "label": "Vendor report",
                "path": "/:lng/home/account_payment/report",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    "export": false
                }
            }
        ]
    },
    {
        "eventKey": "booking_engine_setting",
        "label": "Booking Engine Settings",
        "path": "/:lng/settings/booking_engine_setting",
        "crud": false,
        "read": false,
        "write": false,
        "actions": {
            // "create": false,
            "edit": false,
            // "delete": false
        }
    },
    {
        "eventKey": "slot_configuration",
        "label": "Slot Configuration",
        "path": "/:lng/settings/slot_configuration",
        "crud": false,
        "read": false,
        "write": false,
        "actions": {
            "create": false,
            // "edit": false,
            // "delete": false
        }
    },
    {
        "eventKey": "staff",
        "label": "Staffs",
        "path": "/:lng/home/staff",
        "crud": false,
        "read": false,
        "write": false,
        "actions": {
            "create": false,
            "edit": false,
            "history": false
        }
    },
    {
        "eventKey": "document_management",
        "label": "Documents",
        "path": "/:lng/home/document_management",
        "crud": false,
        "read": false,
        "write": false,
        "actions": {
            "create": false,
            "view":false,
            "share": false,
            "delete": false
        }
    },
    {
        "eventKey": "revenue_manager",
        "label": "Revenue Manager",
        "path": "/:lng/revenue_manager",
        "crud": false,
        "read": false,
        "write": false,
        "subeventKey": [
            {
                "eventKey": "pricing",
                "label": "Pricing",
                "path": "/:lng/home/revenue_manager/pricing",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    "create": false,
                    "edit": false,
                    "delete": false,
                    "change_status": false,
                    "clone_rule": false,
                    "import_rule": false,
                    "export_rule": false,
                    "run": false
                }
            },
            {
                "eventKey": "availability",
                "label": "Availability",
                "path": "/:lng/home/revenue_manager/availability",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    "create": false,
                    "edit": false,
                    "delete": false,
                    "change_status": false,
                    "clone_rule": false,
                    "import_rule": false,
                    "export_rule": false,
                    "run": false
                }
            },
            {
                "eventKey": "calender",
                "label": "Calender",
                "path": "/:lng/home/revenue_manager/calender",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                }
            },
            {
                "eventKey": "events",
                "label": "Events",
                "path": "/:lng/home/revenue_manager/events",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                    "create": false,
                    "edit": false,
                    "delete": false,
                    "import": false,
                    "export": false
                }
            },
            {
                "eventKey": "analytics",
                "label": "Analytics",
                "path": "/:lng/home/revenue_manager/analytics",
                "crud": false,
                "read": false,
                "write": false,
                "actions": {
                }
            },
            {
                "eventKey": "competitors",
                "label": "Competitors",
                "path": "/:lng/home/revenue_manager/competitors",
                "crud": false,
                "read": false,
                "write": false,
                "subeventKey": [
                    {
                        "eventKey": "30_day_pricing_analysis",
                        "label": "30-Day Pricing Analysis",
                        "crud": false,
                        "read": false,
                        "write": false,
                        "actions": {
                            "start_analysis_now": false,
                            "map_rooms": false,
                            "apply_price_changes": false
                        }
                    },
                    {
                        "eventKey": "manage_competitors",
                        "label": "Manage Competitors",
                        "crud": false,
                        "read": false,
                        "write": false,
                        "actions": {
                            "add_competitors": false
                        }
                    }
                ]
            }
        ]
    }
];

// Helper function to get default role data (deep clone to avoid mutations)
export const getDefaultRoleData = () => {
    return JSON.parse(JSON.stringify(DEFAULT_ROLE_DATA));
};

// Keep backward compatibility
export const RoleMenu = DEFAULT_ROLE_DATA